/**
 * Product showcase: Motion-powered scroll-in (opacity + horizontal slide), with CSS + IO fallback.
 * Motion loads from esm.sh; if blocked (CSP), fallback runs automatically.
 */
(async function initProductShowcaseMotion() {
  const collectRoots = () =>
    document.querySelectorAll(
      ".js-product-showcase-fanxcloud[data-motion-on='true']"
    );

  const prefersReduced =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const revealAll = () => {
    collectRoots().forEach((root) => {
      root.querySelectorAll("[data-motion-showcase]").forEach((el) => {
        el.classList.add("is-inview");
      });
    });
  };

  if (prefersReduced) {
    revealAll();
    document.addEventListener("shopify:section:load", revealAll);
    return;
  }

  let motion = null;
  try {
    motion = await import("https://esm.sh/motion@11.15.0");
  } catch (_e) {
    motion = null;
  }

  const setupTarget = (root, el) => {
    if (el.dataset.motionInit === "1") return;
    el.dataset.motionInit = "1";

    const raw = el.getAttribute("data-motion-x");
    const startX = raw == null || raw === "" ? 0 : Number(raw);
    const duration = Number(root.dataset.motionDuration || "0.8") || 0.8;
    const amount = Number(root.dataset.motionAmount || "0.25") || 0.25;

    if (motion && motion.inView && motion.animate) {
      motion.inView(
        el,
        () => {
          motion.animate(
            el,
            { opacity: [0, 1], x: [startX, 0] },
            { duration, ease: [0.25, 0.1, 0.25, 1] }
          );
        },
        { once: true, amount }
      );
      return;
    }

    root.classList.add("product-showcase-fanxcloud--motion-fallback");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-inview");
          io.unobserve(entry.target);
        });
      },
      { root: null, threshold: amount }
    );
    io.observe(el);
  };

  const attach = () => {
    collectRoots().forEach((root) => {
      root.querySelectorAll("[data-motion-showcase]").forEach((el) =>
        setupTarget(root, el)
      );
    });
  };

  attach();
  document.addEventListener("shopify:section:load", attach);
})();
